<template>
	<Head title="Editar Computador"></Head>
	<div class="row mb-5">
		<div>
			<span class="fs-1 fw-bolder me-3">{{ props.computer.descricao }}</span>
			<span class="badge me-2"
				:class="{
					'bg-success': agent_is_connected,
					'bg-danger': !agent_is_connected,
				}">
				{{ agent_is_connected ? 'Agente: Conectado' : 'Agente: Desconectado' }}
			</span>
			<StreamingStatusPill class="me-2" kind="webcam"
				:status="webcam_status" :reason="webcam_status_reason" />
			<StreamingStatusPill v-if="props.is_master_user" kind="screen"
				:status="screen_status" :reason="screen_status_reason" />
		</div>
	</div>
	<div class="card shadow-sm mb-5">
		<div class="card-header card-header-stretch">
			<div class="card-toolbar py-5 hover-scroll-x">
				<ul
					class="nav nav-tabs flex-nowrap text-nowrap nav-line-tabs nav-stretch fs-6 border-0">
					<li class="nav-item">
						<a
							class="nav-link text-black active"
							data-bs-toggle="tab"
							href="#kt_tab_pane_1"
							>Editar dados</a
						>
					</li>
					<li class="nav-item" v-if="props.is_master_user">
						<a
							class="nav-link text-black"
							data-bs-toggle="tab"
							href="#kt_tab_pane_2"
							>Transmissões</a
						>
					</li>
					<li class="nav-item" v-if="props.is_master_user">
						<a
							class="nav-link text-black"
							data-bs-toggle="tab"
							href="#kt_tab_pane_3"
							>Biometria</a
						>
					</li>
					<li class="nav-item" v-if="props.is_master_user">
						<a
							class="nav-link text-black"
							data-bs-toggle="tab"
							href="#kt_tab_pane_4"
							>Controle manual</a
						>
					</li>
					<li class="nav-item" v-if="props.is_master_user">
						<a
							class="nav-link text-black"
							data-bs-toggle="tab"
							href="#kt_tab_pane_5"
							>Logs</a
						>
					</li>
					<li class="nav-item" v-if="props.is_master_user">
						<a
							class="nav-link text-black"
							data-bs-toggle="tab"
							href="#kt_tab_pane_6"
							>Configuração do computador</a
						>
					</li>
					<li class="nav-item">
						<a
							class="nav-link text-black"
							data-bs-toggle="tab"
							href="#kt_tab_pane_7">
							Instalação e Downloads
						</a>
					</li>
					<li class="nav-item">
						<a
							class="nav-link text-black"
							data-bs-toggle="tab"
							href="#kt_tab_pane_8">
							Dashboard
						</a>
					</li>
                    <li class="nav-item" v-if="props.is_master_user">
                        <a
                            class="nav-link text-black"
                            data-bs-toggle="tab"
                            href="#kt_tab_pane_9">
                            Acesso remoto
                        </a>
                    </li>
				</ul>
			</div>
		</div>
		<div class="card-body">
			<div class="tab-content" id="myTabContent">
				<div
					class="tab-pane fade show active"
					id="kt_tab_pane_1"
					role="tabpanel">
					<edit_info
						:computer="props.computer"
						:dvrs="props.dvrs"
						:subtenant_list="props.subtenant_list"
						:is_master_user="props.is_master_user"
						:update_computer_url="props.update_computer_url" />
				</div>

				<div class="tab-pane fade" id="kt_tab_pane_2" role="tabpanel">
					<transmitions_test
                        :screen_webrtc_streaming_source="props.screen_webrtc_streaming_source"
                        :webcam_webrtc_streaming_source="webcam_webrtc_streaming_source"
						:computer_uid="props.computer.uid"
						:enrollment_test_id="props.enrollment_test_id"
						:devices_commands_urls="props.devices_commands_urls"
						:dvr_id="props.computer.dvr_id"
						:dvrs_page_url="props.dvrs_page_url"
                        :webcam_already_started="webcam_status === 'active' || webcam_status === 'degraded'"
                        :screen_already_started="screen_status === 'active' || screen_status === 'degraded'"
                        :webcam_commands_enabled="props.computer.webcam_streaming_mode !== 'browser_webrtc'"
                        :streaming_auth_credential="props.streaming_auth_credential"
                    />
				</div>

				<div class="tab-pane fade" id="kt_tab_pane_3" role="tabpanel">
					<biometry
						:computer_uid="props.computer.uid"
						:enrollment_test_id="props.enrollment_test_id"
						:request_biometry_url="
							props.devices_commands_urls.request_biometry
						" />
				</div>

				<div class="tab-pane fade" id="kt_tab_pane_4" role="tabpanel">
					<manual_control
						:computer_uid="props.computer.uid"
						:manual_command_url="
							props.devices_commands_urls.manual_command
						" />
				</div>

				<div class="tab-pane fade" id="kt_tab_pane_5" role="tabpanel">
					<logs :logs_websocket_url="props.logs_websocket_url" />
				</div>

				<div class="tab-pane fade" id="kt_tab_pane_6" role="tabpanel">
					<computer_configuration
						:computer_uid="props.computer.uid"
						:find_agent_url="props.devices_commands_urls.find_agent"
						:block_computer_url="
							props.devices_commands_urls.block_computer
						"
						:scan_computer_url="
							props.devices_commands_urls.scan_computer
						"
						:computer_info="props.computer_info" />
				</div>

				<div class="tab-pane fade" id="kt_tab_pane_7" role="tabpanel">
					<installation_and_downloads
						:agent_installation_code="
							props.computer.agent_installation_code
						"
						:generate_installation_code_url="
							props.devices_commands_urls
								.generate_agent_installation_code
						"
						:reset_agent_installation_url="
							props.devices_commands_urls.reset_agent_installation
						"
						:computer_id="props.computer.id" />
				</div>
				<div class="tab-pane fade" id="kt_tab_pane_8" role="tabpanel">
					<dashboard
						:computer_uid="$props.computer.uid"
						:grafana="$props.grafana" />
				</div>
                <div class="tab-pane fade" id="kt_tab_pane_9" role="tabpanel">
					<tactical_remote_access
						v-if="props.is_master_user"
						:enabled="props.tactical_remote_access_enabled"
						:remote-access-url="props.tactical_remote_access_url" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import edit_info from '../../components/Computer/edit_info.vue';
	import transmitions_test from '../../components/Computer/transmitions_test.vue';
	import biometry from '../../components/Computer/biometry.vue';
	import manual_control from '../../components/Computer/manual_control.vue';
	import logs from '../../components/Computer/logs.vue';
	import computer_configuration from '../../components/Computer/computer_configuration.vue';
	import installation_and_downloads from '../../components/Computer/installation_and_downloads.vue';
	import dashboard from '../../components/Computer/dashboard.vue';
	import tactical_remote_access from '../../components/Computer/tactical_remote_access.vue';
    import StreamingStatusPill from '../../components/Streaming/StatusPill.vue';
	import { Head } from '@inertiajs/vue3';
	import { Computer } from '../../Interfaces/Computer';
	import { SubTenant } from '../../Interfaces/SubTenant';
	import { provide, inject } from 'vue';
	import { ref } from 'vue';

	const props = defineProps({
		computer: { type: Object as () => Computer, required: true },
		dvrs: { type: Object, required: true },
		subtenant_list: { type: Array<SubTenant>, required: true },
		update_computer_url: { type: String, required: true },
		enrollment_test_id: { type: String, required: true },
		devices_commands_urls: { type: Object, required: true },
		dvrs_page_url: { type: String, required: true },
		logs_websocket_url: { type: String, required: true },
		is_master_user: { type: Boolean, required: true },
		agent_installer_download_url: { type: String, required: true },
		agent_connected: { type: Boolean, required: true },
		webcam_connected: { type: Boolean, required: true },
		screen_connected: { type: Boolean, required: true },
		agent_connection_ws_url: { type: String, required: true },
		streaming_notifications_ws_url: { type: String, required: true },
		streaming_notifications_master_ws_url: { type: String, required: false, default: null },
		computer_info: { type: Object, required: true },
		grafana: { type: Object, required: true },
        webcam_webrtc_streaming_source: { type: String, required: true },
        screen_webrtc_streaming_source: { type: String, required: true },
        streaming_auth_credential: { type: String, required: true },
		tactical_remote_access_enabled: { type: Boolean, required: true },
		tactical_remote_access_url: { type: String, required: true },
	});

	provide(
		'save_hardware_configuration_url',
		props.devices_commands_urls.save_hardware_configuration
	);

	provide('agent_installer_download_url', props.agent_installer_download_url);

    provide('computer', props.computer)

	const emitter: any = inject('emitter');

	const agent_is_connected = ref(props.agent_connected);

	const webcam_status = ref(props.computer.webcam_status ?? 'unknown');
	const webcam_status_reason = ref(props.computer.webcam_status_reason ?? null);
	const webcam_webrtc_streaming_source = ref(props.webcam_webrtc_streaming_source);
	const screen_status = ref(props.computer.screen_status ?? 'unknown');
	const screen_status_reason = ref(props.computer.screen_status_reason ?? null);

	// Two distinct subscriptions — agent-uuid channel for process-connection
	// state (owned by agent-manager) and per-subtenant admin channel for
	// stream state (owned by ead-platform; the StreamingEventController
	// handlers broadcast WEBCAM-* / SCREEN-* on this channel).
	const ws = new WebSocket(props.agent_connection_ws_url);
	ws.onmessage = (message) => {
		const data = JSON.parse(message.data);

        if (data.type === 'agent/status-change') {
            agent_is_connected.value = !!data.online;
        }
	};

	function handleStreamingNotification(message: MessageEvent) {
		const data = JSON.parse(message.data);
		if (data.event !== 'NOTIFICATIONS/NEW') return;

		const payload = data.payload ?? {};
		// The channel is per-subtenant — many computers' events flow through
		// here. Only react to events for the computer this page is editing.
		if (payload.computer_uid && payload.computer_uid !== props.computer.uid) return;

		switch (data.subevent) {
			case 'WEBCAM-ONLINE':
			case 'WEBCAM-DEGRADED':
			case 'WEBCAM-OFFLINE':
				webcam_status.value = payload.status ?? 'unknown';
				webcam_status_reason.value = payload.reason ?? null;
				if (payload.webcam_webrtc_streaming_source) {
					webcam_webrtc_streaming_source.value = payload.webcam_webrtc_streaming_source;
				}
				break;
			case 'SCREEN-ONLINE':
			case 'SCREEN-DEGRADED':
			case 'SCREEN-OFFLINE':
				screen_status.value = payload.status ?? 'unknown';
				screen_status_reason.value = payload.reason ?? null;
				break;
			case 'STREAM-AUTO-STOPPED':
				webcam_status.value = 'offline';
				webcam_status_reason.value = payload.reason ?? null;
				screen_status.value = 'offline';
				screen_status_reason.value = payload.reason ?? null;
				// Tell the local video players to stop reconnecting; the
				// stream is already gone server-side.
				emitter?.emit('stream_auto_stopped');
				//@ts-ignore
				toastr.info(
					'Webcam e tela paradas automaticamente - nenhuma prova ativa neste computador.'
				);
				break;
		}
	}

	const streaming_ws = new WebSocket(props.streaming_notifications_ws_url);
	streaming_ws.onmessage = handleStreamingNotification;

	// Master users get a second subscription on the per-subtenant master
	// channel. The auto-stop sweep broadcasts STREAM-AUTO-STOPPED on both
	// admin and master channels so anyone editing this computer sees it.
	const streaming_ws_master = props.streaming_notifications_master_ws_url
		? new WebSocket(props.streaming_notifications_master_ws_url)
		: null;
	if (streaming_ws_master) {
		streaming_ws_master.onmessage = handleStreamingNotification;
	}
</script>
